/*============ Content Controller
	================================*/
angular
.module('vppApp')
.controller('headlineController', headlineController);

headlineController.$inject = ['$scope', 'headlineFactory', 'vppConfig', '$rootScope', '$state', 'ssoUrl'];

function headlineController($scope, headlineFactory, vppConfig, $rootScope, $state, ssoUrl) {

	$rootScope.ssoUrl = (ssoUrl && ssoUrl.data) ? ssoUrl.data : null;
	$rootScope.siteName = vppConfig.siteNames[vppConfig.folderPath];

	// check for Child States that contain headlines
	$scope.emailVideo = getParameterByName('email');
	$rootScope.$on('$viewContentLoaded', function(event, viewName) {
		if (viewName === "row-one@shopping-tools" || 
				viewName === "row-one@forgot-password" ||
				viewName === "row-one@create-account" ){
				getHeadline();
		};
	});

	$rootScope.createAnAccountUserType;
	$scope.$watch(function() {
	  return $rootScope.cookie;
	}, function() {
	  getHeadline();

	}, true);


  function getHeadline() {
		headlineFactory().then(function (response) {
	 		$scope.dynamicHeadline = response.data.dynamicHeadline;

	 		if($scope.dynamicHeadline){

	 			if($rootScope.createAnAccountUserType && $scope.dynamicHeadline[$rootScope.createAnAccountUserType]){
	 				$scope.headline = response.data.dynamicHeadline[$rootScope.createAnAccountUserType].headline;
					$scope.heading = $scope.headline.heading;
					$scope.subHeading = $scope.headline.subheading;
					$scope.paragraph = $scope.headline.paragraph;
					$scope.class = $scope.headline.class;
					$scope.iAmId = $scope.headline.iAmId;

	 			}

	 		} else {

				$scope.headline = response.data.headline;
				$scope.heading = $scope.headline.heading;
				$scope.subHeading = $scope.headline.subheading;
				$scope.paragraph = $scope.headline.paragraph;
				$scope.class = $scope.headline.class;
				$scope.iAmId = $scope.headline.iAmId;

	 		}

	 		$scope.$broadcast('fireInterpolateJsonElementDirective');

		});

  }

  getHeadline();

};